<!-- eslint-disable max-len -->
<!--- COMPONENTE PCPartidasActivasYRecientesLineaConAsociacionPedido  ---->
<!---
Descripción del componente:
---------------------------
- Incluye una lista con las partidas activas y las finalizadas recientemente del punto de paletizado seleccionado con información del pedido asociado.

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div class="main-pcPartirasActivasYRecientesLineaConAsociacionPedido">
    <!-- Preloader de carga -->
    <UCPreload :show="mostrarPrecarga" />
    <div>
      <div
        v-for="(penPV, index) in partidasEnPuntoDeVolcado"
        :key="index"
        class="content-partida"
        @click="PartidaSelection(penPV)"
      >
        <!-- <pre>{{ penPV }}</pre> -->
        <div class="content-partida-item padding-half">
          <div class="content-title-line">
            <div class="content-title-line__title">
              {{ penPV.Articulo.Nombre }}
            </div>
            <div class="content-title-line__after">
              <div
                class="content-title-line__after-state"
                :class="{
                  'content-title-line__after-state--red': TextoFueraUso(penPV) === $t('production.common.inactive'),
                  'content-title-line__after-state--orange': TextoFueraUso(penPV) === $t('production.common.active'),
                }"
              >
                {{ TextoFueraUso(penPV) }}
              </div>
              <div class="content-title-line__after--time">
                {{ GetHoursAndMinuts(penPV.FechaVolcado) }}
              </div>
            </div>
          </div>
          <div class="content-subtitle">
            <div class="content-subtitle__strong">
              {{ `${penPV.Partida.Serie}/${FormatearIdentificadorPartida(penPV.Partida.Numero)}` }}
            </div>
            <div class="content-subtitle__gray">
              {{ penPV.PuntoVolcado.Codigo }}
            </div>
          </div>
          <div>
            <PCOperacionesPersonalizadas
              v-if="personalizacionTarjetaPartidasActiva"
              :tipo-entidad="1"
              :entidad="{ Id: penPV.Partida.Id }"
              :no-permitidos="['boton']"
              formulario-padre="frmPaletizado"
              componente-aplicacion="PCPartidasActivasYRecientesLineaConAsociacionPedido"
              :mostrar-precarga="false"
              :modo-consulta-agrupada="true"
              :datos="datosPartidasParaPersonalizaciones"
            />
          </div>
          <div class="content-text">
            {{ ConcatStringSalesOrder(penPV.Detalle) }}
          </div>
          <div class="content-footer">
            <div class="content-footer__item">
              <div class="content-footer__item--data">
                {{ penPV.CantidadVolcada }}
              </div>
              <div class="content-footer__item--title">
                {{ $t('production.common.dumpedKilos').toUpperCase() }}
              </div>
            </div>
            <div class="content-footer__item">
              <div class="content-footer__item--data">
                {{ penPV.CantidadConfeccionada }}
              </div>
              <div class="content-footer__item--title">
                {{ $t('production.common.packagedKilos').toUpperCase() }}
              </div>
            </div>
            <div class="content-footer__item">
              <div class="content-footer__item--orange">
                {{ penPV.CantidadDisponible }}
              </div>
              <div class="content-footer__item--title">
                {{ $t('production.common.availableKilos').toUpperCase() }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup Detalle partida Volcada -->
    <f7-popup
      class="popup-partida-volcada"
      :opened="popupDetallePartidaVolcada"
      @popup:closed="popupDetallePartidaVolcada = false"
    >
      <f7-navbar
        :title="$t('production.common.outOfUseByOrderLine')"
        sliding
      >
        <f7-nav-right>
          <f7-link @click="popupDetallePartidaVolcada = false">
            <img
              class="padding-right-half"
              :src="icClose"
            >
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div
        v-if="seleccionPartida != null"
        class="padding"
      >
        <div class="popup-partida-volcada-header padding-bottom">
          <div class="popup-partida-volcada-title">
            <div class="popup-partida-volcada-title__strong">
              {{ `${seleccionPartida.Partida.Serie}/${FormatearIdentificadorPartida(seleccionPartida.Partida.Numero)}` }}
            </div>
            <div class="popup-partida-volcada-title__gray">
              {{ seleccionPartida.PuntoVolcado.Codigo }}
            </div>
          </div>
          <div class="popup-partida-volcada-after">
            <div
              class="seleccionable"
              @click="SelectAndDeselectAllPartidas()"
            >
              <span v-if="!allPartidasSelected">
                {{ $t('common.selectAll') }}
              </span>
              <span v-if="allPartidasSelected">
                {{ $t('common.unselectAll') }}
              </span>
            </div>
          </div>
        </div>
        <div class="content-popup-partida-volcada">
          <f7-list media-list>
            <f7-list-item
              v-for="(item, index) in seleccionPartida.Detalle"
              :key="index"
              :title="`${item.LineaPedidoVenta.PedidoVenta.Serie}/${item.LineaPedidoVenta.PedidoVenta.Numero}-${item.LineaPedidoVenta.Orden
              } ${item.LineaPedidoVenta.PedidoVenta.Cliente ? (` → ${item.LineaPedidoVenta.PedidoVenta.Cliente.Nombre}`) : ''}`"
              :subtitle="item.LineaPedidoVenta.InfoProducto ? item.LineaPedidoVenta.InfoProducto.Nombre : ''"
              @click="PartidaSelectionInPopup(item)"
            >
              <template #media>
                <div>
                  <img
                    v-if="item.Seleccionada === true"
                    src="@/static/icons/ic_checked_on.svg"
                    width="18"
                    height="18"
                  >
                  <img
                    v-else
                    src="@/static/icons/ic_checked_off.svg"
                    width="18"
                    height="18"
                  >
                </div>
              </template>

              <template #after>
                <div>
                  <div
                    v-if="item.FueraUso"
                    class="item-after__state--red"
                  />
                  <span>
                    {{ GetDate(item.LineaPedidoVenta.PedidoVenta.FechaSalida) }}
                  </span>
                </div>
              </template>
            </f7-list-item>
          </f7-list>
        </div>
        <div class="popup-partida-volcada-footer padding-vertical-half">
          <f7-button
            color="gray"
            @click="CancelEditActivePartidas()"
          >
            {{ $t('common.cancel') }}
          </f7-button>
          <f7-button
            color="orange"
            @click="ConfirmEditActivePartidas()"
          >
            {{ $t('common.confirm') }}
          </f7-button>
        </div>
      </div>
    </f7-popup>

    <!-- Popup más partidas volcadas -->
    <f7-popup
      class="popup-partida-volcada"
      :opened="popupVerMasPartidaVolcada"
      @popup:closed="popupVerMasPartidaVolcada = false"
    >
      <f7-navbar
        :title="$t('production.common.dumpedBatches')"
        sliding
      >
        <f7-nav-right>
          <f7-link @click="popupVerMasPartidaVolcada = false">
            <img
              class="padding-right-half"
              :src="icClose"
              width="12"
              height="12"
            >
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div
        class="main-popupMasPartidas"
      >
        <div
          v-for="(penPV, index) in partidasEnPuntoDeVolcado"
          :key="index"
          class="content-partida"
          @click="PartidaSelection(penPV)"
        >
          <div class="content-partida-item padding">
            <div class="content-title-line">
              <div class="content-title-line__title">
                {{ penPV.Articulo.Nombre }}
              </div>
              <div class="content-title-line__after">
                <div
                  class="content-title-line__after-state"
                  :class="{
                    'content-title-line__after-state--red': TextoFueraUso(penPV) === $t('production.common.inactive'),
                    'content-title-line__after-state--orange': TextoFueraUso(penPV) === $t('production.common.active'),
                  }"
                >
                  {{ TextoFueraUso(penPV) }}
                </div>
                <div class="content-title-line__after--time">
                  {{ GetDate(penPV.FechaVolcado) }}
                </div>
              </div>
            </div>
            <div class="content-subtitle">
              <div class="content-subtitle__strong">
                {{ `${penPV.Partida.Serie}/${FormatearIdentificadorPartida(penPV.Partida.Numero)}` }}
              </div>
              <div class="content-subtitle__gray">
                {{ penPV.PuntoVolcado.Codigo }}
              </div>
            </div>
            <div class="content-text">
              {{ ConcatStringSalesOrder(penPV.Detalle) }}
            </div>
            <div class="content-footer">
              <div class="content-footer__item">
                <div class="content-footer__item--data">
                  {{ penPV.CantidadVolcada }}
                </div>
                <div class="content-footer__item--title">
                  {{ $t('production.common.dumpedKilos').toUpperCase() }}
                </div>
              </div>
              <div class="content-footer__item">
                <div class="content-footer__item--data">
                  {{ penPV.CantidadConfeccionada }}
                </div>
                <div class="content-footer__item--title">
                  {{ $t('production.common.packagedKilos').toUpperCase() }}
                </div>
              </div>
              <div class="content-footer__item">
                <div class="content-footer__item--orange">
                  {{ penPV.CantidadDisponible }}
                </div>
                <div class="content-footer__item--title">
                  {{ $t('production.common.availableKilos').toUpperCase() }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </f7-popup>

    <UCConfirmation ref="UCConfirmation" />
  </div>
</template>

<script>
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import SoportePersonalizacion from '@/js/services/soportePersonalizacion';
import SoporteNumeracion from '@/js/common/HiNumerationSupport';
import UCPreload from '@/components/common/UCPreload.vue';
import {
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import icClose from '@/static/icons/ic_cancel.svg';
import PCOperacionesPersonalizadas from './PCOperacionesPersonalizadas.vue';

export default {
  name: 'PCPartidasActivasYRecientesLineaConAsociacionPedido',
  components: {
    UCPreload,
    UCConfirmation,
    PCOperacionesPersonalizadas,
  },
  props: {
    intervaloActualizacionAutomatica: { type: Number, default: 0 }, // Se indica en Segundos y actualizara el resumen.
    puntoPaletizadoSeleccionado: { type: Object, default: null }, // Si se establece un punto se filtraran por los puntos de volcado asociados a cada punto de paletizado.
    lineaProduccionSeleccionada: { type: Object, default: null },
  },

  emits: [
    'partidasActivas',
    'inicioCargaDatos',
    'finCargaDatos',
  ],

  data() {
    return {
      // lineaProduccion: null,
      mostrarPrecarga: false, // Muestra el componente de carga del resumen.
      partidasEnPuntoDeVolcado: [],
      seleccionPartida: null, // Contiene el elemento de partida seleccionado.
      popupDetallePartidaVolcada: false, // Controla la apertura del popup  que el detalle de las partidas volcadas con asociación de pedido.
      popupVerMasPartidaVolcada: false, // Controla la apertura del popup que muestra más partidas.

      /**
       * Mantiene el timer que realiza las actualizaciones automáticas.
       * @type {ReturnType<typeof setTimeout> | null}
       */
      actualizadorAutomatico: null,

      icClose,
      datosPartidasParaPersonalizaciones: [], // Contiene un listado de los datos de las partidas visualizadas para ser utilizado en la consulta de personalizaciones
      personalizacionTarjetaPartidasActiva: false,
    };
  },
  computed: {
    allPartidasSelected() {
      return this.seleccionPartida.Detalle.every((item) => item.Seleccionada === true);
    },
  },
  watch: {
    puntoPaletizadoSeleccionado() {
      this.RestablecerValores();
      this.ActualizarDatos(true);
    },
    partidasEnPuntoDeVolcado(val) {
      this.$emit('partidasActivas', this.partidasEnPuntoDeVolcado.filter((item) => item.FueraUso === false).map((item) => item.Partida));
      if (val !== null && val.length > 0) {
        this.ObtenerPersonalizacionesPlanificaciones(val);
      }
    },
  },
  created() {
    this.InicializarComponente();
  },
  unmounted() {
    this.EliminarIntervaloActualizacionesAutomaticas();
  },
  methods: {
    InicializarComponente() {
      Log(this, this.InicializarComponente.name);
      if (this.intervaloActualizacionAutomatica > 0) {
        this.ProgramarIntervaloActualizacionesAutomaticas();
      }
      this.ActualizarDatos(true);

      this.ConfigurarPersonalizacionesFrm();
    },

    async ActualizarDatos(mostrarPrecarga) {
      Log(this, this.ActualizarDatos.name);
      this.RestablecerValores();
      const self = this;
      if (this.lineaProduccionSeleccionada == null) {
        return;
      }
      self.mostrarPrecarga = mostrarPrecarga !== undefined ? mostrarPrecarga : true;
      if (this.puntoPaletizadoSeleccionado != null) {
        const result = await this.ConsultaPartidasVolcadasSegunConsumo();
        if (result != null) {
          this.partidasEnPuntoDeVolcado = result;
          // Ordenar las partidas por la FechaVolcado descendente.
          this.partidasEnPuntoDeVolcado.sort((a, b) => {
            if (a.FechaVolcado < b.FechaVolcado) {
              return 1;
            }
            if (a.FechaVolcado > b.FechaVolcado) {
              return -1;
            }
            return 0;
          });
        }
        this.mostrarPrecarga = false;
        /*
        this.ConsultaPartidasVolcadasSegunConsumo().then((result) => {
          self.partidasEnPuntoDeVolcado = result;
          self.mostrarPrecarga = false;
        }).catch((error) => {
          self.mostrarPrecarga = false;
          HiNotification.Toast(error);
        });
        */
      }
    },

    /**
     * @public
     * @returns {void}
     */
    RestablecerValores() {
      Log(this, this.RestablecerValores.name);
      this.partidasEnPuntoDeVolcado = [];
    },
    TextoFueraUso(penPV) {
      if (penPV.FueraUso) {
        return this.$t('production.common.inactive');
      }
      if (!penPV.FueraUso && this.HasItemsOutOfUse(penPV.Detalle)) {
        return this.$t('production.common.partiallyActive');
      }
      return this.$t('production.common.active');
    },

    ConfigurarPersonalizacionesFrm() {
      Log(this, this.ConfigurarPersonalizacionesFrm.name);
      this.personalizacionTarjetaPartidasActiva = SoportePersonalizacion.ExistePersonalizacion('frmPaletizado', 'PCPartidasActivasYRecientesLineaConAsociacionPedido');
    },

    async ObtenerPersonalizacionesPlanificaciones(lstPartidas) {
      Log(this, this.ObtenerPersonalizacionesPlanificaciones.name);
      if (!this.personalizacionTarjetaPartidasActiva) {
        return;
      } // Comprurba si esta activa.
      this.datosPartidasParaPersonalizaciones = [];
      const entidades = [];
      lstPartidas.forEach((e) => {
        const array = entidades.filter((f) => f.Id === e.Partida.Id);
        if (array.length < 1) {
          entidades.push({ Id: e.Partida.Id });
        }
      });

      this.datosPartidasParaPersonalizaciones = await SoportePersonalizacion.ObtenerOperacionesPersonalizadasEntidadMultiple(entidades, 1, 'frmPaletizado', 'PCPartidasActivasYRecientesLineaConAsociacionPedido');
    },

    PartidaSelection(value) {
      Log(this, this.PartidaSelection.name);
      if (value.Detalle.length > 0) {
        this.seleccionPartida = value;
        this.popupDetallePartidaVolcada = true;
      } else {
        this.$refs.UCConfirmation.create(
          this.$t('production.changeBatchOutOfUseStatus.title'),
          value.FueraUso ? this.$t('production.changeBatchOutOfUseStatus.use') : this.$t('production.changeBatchOutOfUseStatus.outOfUse'),
          () => {
            this.ChangeStateOutOfUsePartida(value);
          },
        );
        this.$refs.UCConfirmation.show();
      }
    },

    FormatearIdentificadorPartida(identificadorPartida) {
      return SoporteNumeracion.EstablecerLogitudFija(identificadorPartida, 7);
    },
    ProgramarIntervaloActualizacionesAutomaticas() {
      Log(this, this.ProgramarIntervaloActualizacionesAutomaticas.name);
      // const self = this;
      this.actualizadorAutomatico = setInterval(
        () => {
          if (this.popupDetallePartidaVolcada || this.popupVerMasPartidaVolcada) {
            return;
          }
          this.ActualizarDatos(false);
        },
        this.intervaloActualizacionAutomatica * 1000,
      );
    },

    EliminarIntervaloActualizacionesAutomaticas() {
      Log(this, this.EliminarIntervaloActualizacionesAutomaticas.name);
      if (this.actualizadorAutomatico) {
        clearInterval(this.actualizadorAutomatico);
      }
    },

    PartidaSelectionInPopup(value) {
      Log(this, this.PartidaSelectionInPopup.name);
      this.seleccionPartida.Detalle.forEach((i) => {
        if (i.LineaPedidoVenta.Id === value.LineaPedidoVenta.Id) {
          const foundItem = this.seleccionPartida.Detalle.find((lpv) => lpv.LineaPedidoVenta.Id === value.LineaPedidoVenta.Id);

          if (foundItem) {
            foundItem.Seleccionada = i.Seleccionada !== true;
          }
        }
      });
    },

    SelectAndDeselectAllPartidas() {
      Log(this, this.SelectAndDeselectAllPartidas.name);
      // Si todas las partidas están seleccionadas, deseleccionar todas y si estan seleccionadas deseleccionarlas
      if (this.allPartidasSelected) {
        this.seleccionPartida.Detalle.forEach((i) => {
          i.Seleccionada = false;
        });
      } else {
        this.seleccionPartida.Detalle.forEach((i) => {
          i.Seleccionada = true;
        });
      }
    },

    CancelEditActivePartidas() {
      Log(this, this.CancelEditActivePartidas.name);
      this.popupDetallePartidaVolcada = false;
    },

    async ConfirmEditActivePartidas() {
      Log(this, this.ConfirmEditActivePartidas.name);
      const lpvSeleccionadasPonerFueraUso = this.seleccionPartida.Detalle.filter((i) => i.Seleccionada === true && i.FueraUso === false).map((i) => i.LineaPedidoVenta);
      const lpvSeleccionadasPonerActivas = this.seleccionPartida.Detalle.filter((i) => i.Seleccionada === true && i.FueraUso === true).map((i) => i.LineaPedidoVenta);
      PreloaderGH(true, true, this.$t('production.info.changingBatchStatus'), '');
      if (lpvSeleccionadasPonerFueraUso.length > 0) {
        await this.CambiarEstadoUsoPartida(this.seleccionPartida.PuntoVolcado.Id, this.seleccionPartida.Partida.Id, true, lpvSeleccionadasPonerFueraUso);
      }
      if (lpvSeleccionadasPonerActivas.length > 0) {
        await this.CambiarEstadoUsoPartida(this.seleccionPartida.PuntoVolcado.Id, this.seleccionPartida.Partida.Id, false, lpvSeleccionadasPonerActivas);
      }
      this.ActualizarDatos(true);
      this.popupDetallePartidaVolcada = false;
      PreloaderGH(false);
    },

    HasItemsOutOfUse(lstItems) {
      Log(this, this.HasItemsOutOfUse.name);
      let hasItemsOutOfUse = false;
      lstItems.forEach((i) => {
        if (i.FueraUso === true) {
          hasItemsOutOfUse = true;
          return true;
        }
        return false;
      });
      return hasItemsOutOfUse;
    },

    async ChangeStateOutOfUsePartida(value) {
      Log(this, this.ChangeStateOutOfUsePartida.name);
      PreloaderGH(true, true, this.$t('production.info.changingBatchStatus'), '');
      await this.CambiarEstadoUsoPartida(value.PuntoVolcado.Id, value.Partida.Id, !value.FueraUso, []);
      this.ActualizarDatos(true);
      PreloaderGH(false);
    },

    /**
     * @public
     * @returns {void}
     */
    VerMasPartidasDeLaColaDeVolcado() {
      Log(this, this.VerMasPartidasDeLaColaDeVolcado.name);
      this.popupVerMasPartidaVolcada = true;
    },

    async CambiarEstadoUsoPartida(idPuntoVolcado, idPartida, fueraUso, listaLineasPedidoVenta) {
      Log(this, this.CambiarEstadoUsoPartida.name);
      if (this.puntoPaletizadoSeleccionado === null) {
        return false;
      }
      const result = await ConexionTA.callGestionarFueraUsoColaVolcado(idPuntoVolcado, idPartida, fueraUso, listaLineasPedidoVenta);
      if (result.Valor) {
        return true;
      }
      const mensaje = result.Mensaje;
      HiNotification.Toast(mensaje !== '' ? mensaje : this.$t('production.info.couldNotChangeBatchStatus'));
      return false;
    },

    ConsultaPartidasVolcadasSegunConsumo() {
      Log(this, this.ConsultaPartidasVolcadasSegunConsumo.name);
      if (this.puntoPaletizadoSeleccionado === null) {
        return null;
      }
      this.$emit('inicioCargaDatos');
      return new Promise((resolve, reject) => {
        ConexionTA.callConsultaPartidasVolcadasSegunConsumo(this.puntoPaletizadoSeleccionado.Id, new Date()).then((result) => {
          if (result.Valor) {
            resolve(JSON.parse(result.Mensaje));
          } else {
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            LogError('error');
            reject(error);
          })
          .finally(() => {
            this.$emit('finCargaDatos');
          });
      });
    },
    ConcatStringSalesOrder(value) {
      if (value == null || value.length === 0) {
        return '';
      }
      let result = '';
      // Concatenar la serie y el número de pedido de la lista value
      for (let i = 0; i < value.length; i += 1) {
        result += `${value[i].LineaPedidoVenta.PedidoVenta.Serie}/${value[i].LineaPedidoVenta.PedidoVenta.Numero}-${value[i].LineaPedidoVenta.Orden}; `;
      }
      result = result.substring(0, result.length - 2);
      return result;
    },
    GetHoursAndMinuts(value) {
      return SoporteFechaYHora.obtenerHorasYMinutos(value);
    },
    GetDate(value) {
      return SoporteFechaYHora.obtenerDDMMAA(value);
    },
  },
};
</script>

<style lang="scss">
.content-partida {
  .content-partida-item {
    border-bottom: 1px solid var(--his-blueberry-frost);

    .content-title-line {
      display: grid;
      grid-template-columns: 2fr 1fr;
      grid-column-gap: 5px;

      &__title {
        color: var(--his-steel-blue);
        font-weight: 500;
        font-size: 18px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 5px;

        .content-title-line-state {
          &__orange,
          &__blue {
            border-radius: 50%;
            height: 12px;
            width: 12px;
            margin-right: 5px;
            background-color: var(--his-orange);
            display: inline-block;
          }

          &__blue {
            background-color: var(--his-steel-blue);
          }
        }
      }

      &__after {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        &--time {
          color: var(--his-steel-blue);
          background-color: var(--his-silver);
          border-radius: 12px;
          font-weight: 500;
          font-size: 14px;
          padding: 2px 7px;
        }
      }

      &__after-state {
        border-radius: 3px;
        font-size: 12px;
        padding: 4px 6px;
        color: #fff;
        width: 72px;
        margin-right: 8px;
        background-color: var(--his-steel-blue);

        &--red {
          background-color: var(--his-red);
        }

        &--orange {
          background-color: var(--his-orange);
        }
      }
    }

    .content-subtitle {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-top: 2px;

      &__strong {
        color: var(--his-steel-blue);
        background-color: var(--his-silver);
        padding: 2px 7px;
        border-radius: 3px;
        font-weight: 500;
        font-size: 16px;
      }

      &__gray {
        font-size: 16px;
        color: #9e9fa3;
        font-weight: 400;
        margin-left: 6px;
      }
    }

    .content-text {
      color: var(--his-oliva);
      font-weight: 500;
      font-size: 14px;
    }

    .content-footer {
      margin-top: 2px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &__item {
        display: flex;
        flex-direction: column;

        &--data {
          font-size: 24px;
          font-weight: 500;
          color: var(--his-steel-blue);
        }

        &--orange {
          font-size: 24px;
          font-weight: 500;
          color: var(--his-mandarina);
        }

        &--title {
          color: var(--his-plum-shadow);
          font-weight: 400;
          font-size: 12px;
        }

        &:nth-child(2) {
          align-items: center;
          justify-content: center;
        }

        &:nth-child(3) {
          align-items: flex-end;
          justify-content: center;
        }
      }
    }
  }
}

.popup-partida-volcada,
.masPartidasVolcadas-popup {
  --f7-navbar-height: 45px;
  --f7-navbar-title-font-size: 16px;
  --f7-navbar-title-font-weight: 400;

  .navbar {
    --f7-navbar-text-color: var(--his-plum-shadow);
  }

  .main-popupMasPartidas {
    height: 60vh;
    overflow-y: auto;
  }

  .popup-partida-volcada-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--his-blueberry-frost);

    .popup-partida-volcada-title {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      &__strong {
        color: var(--his-steel-blue);
        background-color: var(--his-silver);
        padding: 2px 7px;
        border-radius: 3px;
        font-weight: 600;
        font-size: 16px;
      }

      &__gray {
        font-size: 16px;
        color: #9e9fa3;
        font-weight: 400;
        margin-left: 15px;
      }
    }

    .popup-partida-volcada-after {
      >div {
        padding: 12px 14px;
        background-color: #eeece9;
        border: 1px solid var(--his-kiwi-pulp);
        color: var(--his-kiwi-pulp);
        border-radius: 8px;
      }
    }
  }

  .content-popup-partida-volcada {
    --f7-list-margin-vertical: 0;
    --f7-list-item-title-font-size: 18px;
    --f7-list-item-title-text-color: var(--his-steel-blue);
    --f7-list-item-subtitle-font-size: 16px;
    --f7-list-item-subtitle-text-color: #a1a9b7;
    --f7-list-media-item-padding-horizontal: 0;
    --f7-list-item-border-color: var(--his-blueberry-frost);
    --f7-list-border-color: var(--his-blueberry-frost);

    height: 56vh;
    overflow-y: auto;

    .list ul::before {
      height: 0;
    }

    .list {
      .item-media {
        min-width: 0;
      }

      .item-after {
        >div {
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            color: var(--his-steel-blue);
            background-color: var(--his-silver);
            border-radius: 12px;
            font-weight: 500;
            font-size: 14px;
            padding: 2px 7px;
          }
        }

        &__state {
          &--red {
            background-color: #ff5630;
            border-radius: 50%;
            height: 20px;
            width: 20px;
            margin-right: 10px;
          }
        }
      }
    }
  }

  .popup-partida-volcada-footer {
    position: fixed;
    bottom: 0;
    width: calc(100% - var(--f7-typography-padding) * 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ebecf0;
  }
}

.main-pcPartirasActivasYRecientesLineaConAsociacionPedido {
  background-color: var(--his-tierra-white);

  .div-registroPartida {
    padding-top: 8px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid var(--his-disabled);
  }

  .col-indicadorEstadoVolcado {
    padding-top: 5px;
    padding-right: 10px;
  }

  .col-horaVolcadoPartida {
    text-align: -webkit-right;
    margin-right: 5px;
  }

  .div-rectanguloUso {
    background-color: var(--his-steel-blue);
    border-radius: 3px;
    width: 78px;
    height: 19px;
    margin-left: 10px;
    margin-right: 10px;
    text-align: center;
    color: #fff;
    font-size: 12px;
  }

  .div-rectanguloUso-red {
    background-color: #ff5630;
  }

  .div-rectanguloUso-yellow {
    background-color: var(--his-mandarina);
  }
}

/********* Popup Indicador de  lineas de pedido activas **********/
.main-popupPartidas {
  background-color: var(--his-tierra-white);

  .content-head-fixed {
    position: fixed;
    top: var(--f7-navbar-height);
    z-index: 5;
    background-color: var(--his-tierra-white);
    width: 100%;
  }

  .content-head {
    display: flex;
    justify-content: center;

    > div {
      width: 100%;
    }

    .content-head-btnSelectAll {
      background-color: rgb(172 160 149 / 20%);
      border: 1px solid var(--his-kiwi-pulp);
      border-radius: 8px;
      width: 184px;
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .content-head-btnSelectAll span {
      color: var(--his-kiwi-pulp);
      font-size: 18px;
      font-weight: 500;
      letter-spacing: 0.26px;
      line-height: 22px;
      text-align: left;
    }
  }
}
</style>
